import React, { Context } from "react";

const withContext = <T,>(
	context: Context<T>,
) => value => Component => props => {
	return (
		<context.Provider value={value}>
			<Component {...props} />
		</context.Provider>
	);
};

export default withContext;
